import { Component, Input, OnInit, TemplateRef } from '@angular/core';

@Component({
  selector: 'hirit-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
})
export class CardComponent implements OnInit {
  @Input() title!: string;
  @Input() subtitle!: string;
  @Input() headerTemplate: TemplateRef<unknown> | null = null;

  ngOnInit(): void {}
}
